<template>
  <div class="section">
    <div class="container">
      <div class="block mb-4">
        <h1 class="title has-text-centered">Kontaktieren Sie uns!</h1>
        <hr />
      </div>
      <div class="card contact-card">
        <div class="card-content">
          <div class="has-text-centered" style="position: relative; z-index: 2">
            <p>Bei Fragen und Anmerkungen können Sie uns jederzeit per:</p>
            <div
              class="columns is-centered is-gapless is-mobile is-multiline my-2"
            >
              <div class="column is-narrow">
                <a
                  class="px-4 is-flex is-align-items-center"
                  href="mailto:support@standortmonitor.net"
                >
                  <b-icon icon="envelope"></b-icon>
                  <span>support@standortmonitor.net</span>
                </a>
              </div>
              <div class="column is-narrow">
                <a
                  class="px-4 is-flex is-align-items-center"
                  href="tel:030-2462660"
                >
                  <b-icon icon="phone"></b-icon>
                  <span>030-2462660</span>
                </a>
              </div>
            </div>
            <p>Wir freuen uns auf Ihre Nachricht.</p>
          </div>
          <iframe
            class="mailchimp-embed"
            src="https://us7.list-manage.com/contact-form?u=896b13cdad6379da319f86729&form_id=1665987659cb3c1359b820f16ecea35a"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
};
</script>

<style>
.mailchimp-embed {
  width: 100%;
  height: 1000px;
  position: relative;
  z-index: 1;
  margin-top: -75px;
}

@media screen and (min-width: 769px) {
  .card.contact-card,
  .card.contact-card .card-content {
    padding-right: 3rem;
    padding-left: 3rem;
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .mailchimp-embed {
    margin-top: -100px;
  }
}
</style>
